import { render, staticRenderFns } from "./ListDocUser.vue?vue&type=template&id=390fceeb&"
import script from "./ListDocUser.vue?vue&type=script&lang=js&"
export * from "./ListDocUser.vue?vue&type=script&lang=js&"
import style0 from "./ListDocUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports